import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { publicRoutes } from 'shared/hooks/use-user/constants/public-routes';
import { UnauthorizedUser, UserInterface } from 'shared/types/user-interface';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR, { useSWRConfig } from 'swr';
import { DASHBOARD_USER_DATA_API, PUBLIC_USER_DATA_API } from '../constants/api';
export const usePublicUser = () => {
  const $ = _c(9);
  const router = useRouter();
  let t0;
  if ($[0] !== router) {
    t0 = publicRoutes.some(route => router.pathname.includes(route));
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isPublic = t0;
  const {
    cache
  } = useSWRConfig();
  let t1;
  if ($[2] !== cache) {
    t1 = cache.get(DASHBOARD_USER_DATA_API)?.data;
    $[2] = cache;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const dashboardUser = t1;
  const t2 = dashboardUser ? dashboardUser : undefined;
  let t3;
  if ($[4] !== t2) {
    t3 = {
      fallbackData: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: publicUser,
    mutate: publicMutate
  } = useSWR(isPublic && PUBLIC_USER_DATA_API, baseFetcher, t3);
  let t4;
  if ($[6] !== publicMutate || $[7] !== publicUser) {
    t4 = {
      publicUser,
      publicMutate
    };
    $[6] = publicMutate;
    $[7] = publicUser;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};